
import React, { useEffect } from 'react';
import { AppProviders } from '@/providers/AppProviders';
import EnhancedAppRoutes from '@/routes/EnhancedAppRoutes';
import CookieConsentBanner from "@/components/CookieConsentBanner";
import ErrorBoundary from '@/components/ErrorBoundary';
import { detectAndResolveAuthLimbo } from '@/utils/auth/authCleanup';
import NavigationGuard from '@/components/navigation/NavigationGuard';
import GlobalErrorHandler from '@/components/system/GlobalErrorHandler';

/**
 * Main app component - slimmed down for better performance
 */
function App() {
  // Check for auth issues on startup
  useEffect(() => {
    try {
      // Initialize only once
      detectAndResolveAuthLimbo();
      console.log("App initialized successfully");
    } catch (error) {
      console.error('App initialization error:', error);
    }
  }, []);
  
  return (
    <ErrorBoundary componentName="App">
      <AppProviders>
        <GlobalErrorHandler>
          <NavigationGuard />
          <EnhancedAppRoutes />
          <CookieConsentBanner />
        </GlobalErrorHandler>
      </AppProviders>
    </ErrorBoundary>
  );
};

export default App;
